// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from '../../../../../../shared-components/forms/NumberedHeading';
import WYSIWYGEditor from '../../../../../../shared-components/WYSIWYGEditor';

const EnvironmentScenario = (props) => {
  const { control, errors } = props;

  return (
    <>
      <NumberedHeading
        number="4"
        title="Scenario TL"
        instructions="Fill in a description of the environment's scenario in the target language."
        required
      />
      <Controller
        control={control}
        name="content.scenario.text_tl"
        render={({ field }) => (
          <WYSIWYGEditor {...field} error={errors.content?.scenario?.text_tl} />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="5"
        title="Scenario EN"
        instructions="Fill in a description of the environment's scenario in english."
        required
      />
      <Controller
        control={control}
        name="content.scenario.text_en"
        render={({ field }) => (
          <WYSIWYGEditor {...field} error={errors.content?.scenario?.text_en} />
        )}
      />
    </>
  );
};

export default EnvironmentScenario;
